import Hero from "@/components/home/Hero";
import EditorialMarquee from "@/components/Marquee";
import Manifesto from "@/components/home/Manifesto";
import Services from "@/components/home/Services";
import PricingExample from "@/components/home/PricingExample";
import FleetPreview from "@/components/home/FleetPreview";
import ReviewsSection from "@/components/home/ReviewsSection";
import ReferralStrip from "@/components/home/ReferralStrip";
import TradeInBanner from "@/components/home/TradeInBanner";
import HowItWorks from "@/components/home/HowItWorks";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <Services />
      <PricingExample />
      <FleetPreview />
      <ReviewsSection />
      <ReferralStrip />
      <TradeInBanner />
      <HowItWorks />
    </div>
  );
}
